import React from "react";
import axios from "axios";
import Spinner from "../../components/Spinner";
import { Modal } from "../../components/Modal";
import {primaryLabelName, secondaryLabelName, uniqueIdentifier1Name} from "../../utils/helper"

const API = localStorage.getItem("assethost");

export default class ChangeOwnership extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      msg: "",
      toastColor: "",
      assetId: "",
      assetType: "",
      assetBrand: "",
      assetModel: "",
      assetUniqueIdentier: "",

      mobileNumber: "",
      date: "",
      buyerDetails: null,
      buyerFound: false,
      showConfirm: false,
      errors: {},
      valid: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleLookup = this.handleLookup.bind(this);
    this.handleChangeOwnership = this.handleChangeOwnership.bind(this);
    this.validate = this.validate.bind(this);
    this.loadAssetDetails = this.loadAssetDetails.bind(this);
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    let assetId = urlParams.get("assetId");
    if (!assetId) {
      assetId = this.props.assetId;
    }
    const assetType = this.props.assetType;
    const assetBrand = this.props.assetBrand;
    const assetModel = this.props.assetModel;
    const assetUniqueIdentier = this.props.assetUniqueIdentier;

    if (assetId) {
      this.setState(
        { assetId, assetType, assetBrand, assetModel, assetUniqueIdentier },
        this.loadAssetDetails
      );
    } else {
      this.setState({
        msg: "No asset ID provided",
        toastColor: "danger",
      });
    }
  }

  loadAssetDetails() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true });
    axios
      .get(API + `/asset/getchangeofownershipview/${this.state.assetId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        this.setState({
          assetDetails: response.data,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg:
            error?.response?.data?.message || "Failed to load asset details.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (!s.mobileNumber || !s.mobileNumber.trim()) {
      errors.mobileNumber = "Mobile number is required";
      valid = false;
    } else if (!/^\d{10,15}$/.test(s.mobileNumber.replace(/\s+/g, ""))) {
      errors.mobileNumber = "Please enter a valid mobile number";
      valid = false;
    }

    this.setState({ errors, valid });
    return valid;
  }

  handleLookup(e) {
    e.preventDefault();
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    axios
      .get(API + `/asset/changeofownershipverify/${this.state.mobileNumber}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            buyerDetails: response.data.message || "Buyer found and verified",
            buyerFound: response.data.success,
            loading: false,
          });
        } else {
          this.setState({
            buyerDetails:
              "Buyer not found. A message has been sent to register.",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg:
            error?.response?.data?.message || "Failed to verify mobile number.",
          toastColor: "danger",
        });
      });
  }

  handleChangeOwnership(e) {
    e.preventDefault();
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    const request = {
      assetId: this.state.assetId,
      mobileNumber: this.state.mobileNumber,
      ownerMobileNumber: this.state.assetDetails?.ownerMobileNumber,
      assetNumber: this.state.assetDetails?.assetNumber,
    };

    axios
      .post(API + "/asset/changeofownership", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            msg:
              response.data.message ||
              "Change of ownership initiated successfully! A code has been sent to the buyer to complete the transfer.",
            toastColor: "success",
            loading: false,
          });
          setTimeout(() => {
            this.props.closeAction();
            if (this.props.onSuccess) {
              this.props.onSuccess();
            }
          }, 3000);
        } else {
          this.setState({
            msg: response.data.message || "Change of ownership failed",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            "Change of ownership failed. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return (
        <Modal title="Change of Ownership" footerContent={<></>}>
          <div className="w-100 h-10 overflow-hidden d-flex justify-content-center align-items-center">
            <Spinner className="" />
          </div>
        </Modal>
      );
    }

    return (
      <Modal
        title="Change of Ownership"
        closeAction={this.props.closeAction}
        footerContent={
          <>
            {s.buyerFound && (
              <button
                type="button"
                className="btn btn-primary"
                disabled={!s.valid || !s.buyerDetails}
                onClick={this.handleChangeOwnership}
              >
                Change Ownership
              </button>
            )}
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.props.closeAction}
            >
              Close
            </button>
          </>
        }
      >
        {divMsg}
           <div className="row">
                             <div className="col">
                               <b>{primaryLabelName(s.assetType)}: </b>
                               <span>{s.assetBrand}</span>
                             </div>
                             <div className="col">
                               <b>{secondaryLabelName(s.assetType)}: </b>
                               <span>{s.assetModel}</span>
                             </div>
                           </div>
                           <div className="row">
                             <div className="col">
                               <b>{uniqueIdentifier1Name(s.assetType)}: </b>
                               <span>{s.assetUniqueIdentier}</span>
                             </div>
                           </div>

        <form
          className="d-flex flex-column w-100 mt-2"
          autoComplete="off"
          onSubmit={this.handleChangeOwnership}
        >
          <div className="row">
            <div className="col">
              <div className="input-group">
                <label className="input-group-text">Mobile Number</label>
                <input
                  name="mobileNumber"
                  className={`form-control ${
                    s.errors.mobileNumber ? " !border-red-500" : ""
                  }`}
                  type="tel"
                  value={s.mobileNumber}
                  onChange={this.handleChange}
                  placeholder="Enter buyer's mobile number"
                  required
                />
                {s.errors.mobileNumber && (
                  <span className="input-group-error">
                    {s.errors.mobileNumber}
                  </span>
                )}
              </div>
            </div>
            <div className="col">
              {s.valid && s.mobileNumber && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.handleLookup}
                >
                  Lookup
                </button>
              )}
            </div>
          </div>

          {s.buyerDetails && (
            <div className="row">
              <div className="col">
                <div
                  className={`p-3 rounded ${
                    s.buyerDetails.includes("not found")
                      ? "bg-yellow-50 border border-yellow-200"
                      : "bg-green-50 border border-green-200"
                  }`}
                >
                  <div className="d-flex">
                    <div className="flex-shrink-0">
                      {s.buyerDetails.includes("not found") ? (
                        <svg
                          className="h-5 w-5 text-yellow-400"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                            clipRule="evenodd"
                          />
                        </svg>
                      ) : (
                        <svg
                          className="h-5 w-5 text-green-400"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clipRule="evenodd"
                          />
                        </svg>
                      )}
                    </div>
                    <div className="ml-3">
                      <p
                        className={`text-sm ${
                          s.buyerDetails.includes("not found")
                            ? "text-yellow-700"
                            : "text-green-700"
                        }`}
                      >
                        {s.buyerDetails}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </form>
      </Modal>
    );
  }
}
